
const OrganizationData = {
    "name": "",
    "notes": "",
    "organizationKey":"",
    "theme":"",
    "id": "",
    "version": null,
    "createdAt": "",
    "updatedAt": "",
    "isDeleted": false,
    "deleted": false,
    "organizationId": null,
    "clinics":[],
    "organizationUser": [],
    "ssoProvider":"None",
    "ssoProviderSettingsBlob":JSON.stringify(""),
    "enablePasswordHistory":false,
    "nbOfPasswordInHistory":5,
    "enablePasswordDuration":false,
    "passwordDurationInDays":60,
    "enableLockoutAfterFailedLogin":false,
    "nbOfFailedAttempts":5,
    "lockoutDuration":60,
    "enableTFA":false,
    "minimumPasswordLength":8,
    "softBrandingBlob" :JSON.stringify(""),
    "modules":"",
    "features":"",
    "flexLicenceTemplateName":"",
    "nbOfSeats":0,
    "applications":""
}

export default OrganizationData;